import type { ComponentProps } from "react";
import * as Sentry from "@sentry/react-native";
import _ from "lodash";

type SentryErrorBoundaryProps = ComponentProps<typeof Sentry.ErrorBoundary>;

type ErrorBoundaryProps = SentryErrorBoundaryProps & {
  resetKeys?: unknown;
};

export class ErrorBoundary extends Sentry.ErrorBoundary {
  props: ErrorBoundaryProps;
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.props = props;
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    const props = this.props;
    const prevKeys = prevProps.resetKeys ?? "";
    const currentKeys = props.resetKeys ?? "";
    if (!_.isEqual(prevKeys, currentKeys)) {
      this.resetErrorBoundary();
    }
  }
}
